import types from "./types";

const fetchBenchmarksStart = () => {
  return {
    type: types.FETCH_BENCHMARKS_START,
  };
};

const fetchBenchmarks = (benchmarks) => {
  return {
    type: types.FETCH_BENCHMARKS,
    payload: benchmarks,
  };
};

const fetchBenchmarksError = (err) => {
  return {
    type: types.FETCH_BENCHMARKS_ERROR,
    payload: err,
  };
};

const clear = () => {
  return {
    type: types.CLEAR,
  };
};


const applyBenchmark = (benchmark) => {
  return {
    type: types.APPLY_BENCHMARK,
    payload: benchmark,
  };
};

export default {
  fetchBenchmarks,
  fetchBenchmarksStart,
  fetchBenchmarksError,
  clear,
  applyBenchmark,
};



// WEBPACK FOOTER //
// ./src/redux/benchmarks/actions.js